import React, { FC } from 'react';
import { BodyText, Title } from '@gje/typography/lib';
import { HtmlPanel } from '../HtmlPanel/HtmlPanel';
import { getText } from '../../../services/text/text-service';
import useMobile from '../../../hooks/useMobile';
import classNames from 'classnames';

const fb = require('../../../images/facebook.png');
const tt = require('../../../images/twitter.png');
const yt = require('../../../images/youtube.png');

const FooterVA: FC = () => {
    const isMobileOrSmallScreen = useMobile();

    return (
        <div
            className={classNames(
                'villaagarna-footer-bg-image full-width',
                `villaagarna-footer-bg-padding-${
                    isMobileOrSmallScreen ? 'mobile' : 'desktop'
                }`
            )}>
            <div className={'container'}>
                <div className={'row villaagarna-footer-text-color'}>
                    <div
                        className={classNames({
                            'col-sm-1-5': !isMobileOrSmallScreen
                        })}
                    />
                    <div
                        className={classNames(
                            `col-sm-5 margin-bottom-${
                                isMobileOrSmallScreen ? '26' : '13'
                            }`
                        )}>
                        <Title
                            className={classNames('row', {
                                'margin-bottom-13': !isMobileOrSmallScreen
                            })}
                            tag={'h4'}>
                            {getText(
                                'webshopsweden.common.villaagarna.footer.address'
                            )}
                        </Title>
                        <BodyText>
                            <HtmlPanel>
                                {getText(
                                    'webshopsweden.common.villaagarna.footer.address.sectionContent'
                                )}
                            </HtmlPanel>
                        </BodyText>
                    </div>
                    <div
                        className={classNames(
                            `col-sm-5 margin-bottom-${
                                isMobileOrSmallScreen ? '26' : '13'
                            }`
                        )}>
                        <Title
                            className={classNames('row', {
                                'margin-bottom-13': !isMobileOrSmallScreen
                            })}
                            tag={'h4'}>
                            {getText(
                                'webshopsweden.common.villaagarna.footer.contact'
                            )}
                        </Title>
                        <BodyText>
                            <HtmlPanel className={'word-break-word'}>
                                {getText(
                                    'webshopsweden.common.villaagarna.footer.contact.sectionContent'
                                )}
                            </HtmlPanel>
                        </BodyText>
                    </div>
                    <div
                        className={classNames(
                            `col-sm-5 margin-bottom-${
                                isMobileOrSmallScreen ? '26' : '13'
                            }`
                        )}>
                        <Title
                            className={classNames('row', {
                                'margin-bottom-13': !isMobileOrSmallScreen
                            })}
                            tag={'h4'}>
                            {getText(
                                'webshopsweden.common.villaagarna.footer.moreInfo'
                            )}
                        </Title>
                        <BodyText>
                            <HtmlPanel>
                                {getText(
                                    'webshopsweden.common.villaagarna.footer.moreInfo.sectionContent'
                                )}
                            </HtmlPanel>
                        </BodyText>
                    </div>
                    <div
                        className={classNames(
                            `col-sm-5 margin-bottom-${
                                isMobileOrSmallScreen ? '26' : '13'
                            }`
                        )}>
                        <Title
                            className={classNames('row', {
                                'margin-bottom-13': !isMobileOrSmallScreen
                            })}
                            tag={'h4'}>
                            {getText(
                                'webshopsweden.common.villaagarna.footer.socialMedia'
                            )}
                        </Title>
                        <div className={'row'}>
                            <a href={'https://www.facebook.com/villaagarna/'}>
                                <img
                                    width={'24px'}
                                    height={'24px'}
                                    id={'fb'}
                                    src={fb}
                                    alt="fb"
                                    className={
                                        'margin-right-8 social-media-button-fb'
                                    }
                                />
                            </a>
                            <a href={'https://twitter.com/villaagarna'}>
                                <img
                                    width={'24px'}
                                    height={'24px'}
                                    id={'tt'}
                                    src={tt}
                                    alt="tt"
                                    className={
                                        'margin-right-8 social-media-button-tt'
                                    }
                                />
                            </a>
                            <a
                                href={
                                    'https://www.youtube.com/user/Villaagarna'
                                }>
                                <img
                                    width={'24px'}
                                    height={'24px'}
                                    id={'yt'}
                                    src={yt}
                                    alt="yt"
                                    className={
                                        'margin-right-8 social-media-button-yt'
                                    }
                                />
                            </a>
                        </div>
                    </div>
                    <div
                        className={classNames({
                            'col-sm-1-5': !isMobileOrSmallScreen
                        })}
                    />
                </div>
            </div>
        </div>
    );
};

export default FooterVA;
